(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nt-top-picks-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nt-top-picks-tabs')) {
    customElements.define(
      'nt-top-picks-tabs',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

          this.handleClick = (event) => {
            const tab = event.target.closest('[role="tab"]');
            if (tab && this.tabs.includes(tab)) {
              this.activateTab(tab, true);
            }
          };

          this.handleKeydown = (event) => {
            const tab = event.target.closest('[role="tab"]');
            const currentIndex = this.tabs.indexOf(tab);
            if (currentIndex < 0) return;

            let nextIndex;
            const isRtl = getComputedStyle(this).direction === 'rtl';

            switch (event.key) {
              case 'ArrowRight':
                nextIndex = currentIndex + (isRtl ? -1 : 1);
                break;
              case 'ArrowLeft':
                nextIndex = currentIndex + (isRtl ? 1 : -1);
                break;
              case 'Home':
                nextIndex = 0;
                break;
              case 'End':
                nextIndex = this.tabs.length - 1;
                break;
              default:
                return;
            }

            event.preventDefault();
            nextIndex = (nextIndex + this.tabs.length) % this.tabs.length;
            this.activateTab(this.tabs[nextIndex], true);
          };

          this.handleBlockSelect = (event) => {
            const tab = this.tabs.find((item) =>
              item.id.endsWith('-' + event.detail.blockId)
            );
            if (tab) this.activateTab(tab, false);
          };

          this.handleSubmit = async (event) => {
            const form = event.target.closest('form.nt-top-picks__form');
            if (!form) return;
            event.preventDefault();

            const button = form.querySelector('button[type="submit"]');
            if (!button || button.disabled) return;

            const originalLabel = button.textContent;
            button.disabled = true;
            button.textContent = 'Adding...';

            const root =
              (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

            try {
              const response = await fetch(root + 'cart/add.js', {
                method: 'POST',
                headers: { Accept: 'application/json' },
                body: new FormData(form),
              });
              if (!response.ok) throw new Error('Add to cart failed');

              button.textContent = 'Added ✓';
              setTimeout(() => {
                window.location.assign(root + 'cart');
              }, 400);
            } catch (error) {
              button.disabled = false;
              button.textContent = originalLabel;
              HTMLFormElement.prototype.submit.call(form);
            }
          };

          this.addEventListener('click', this.handleClick);
          this.addEventListener('keydown', this.handleKeydown);
          this.addEventListener('submit', this.handleSubmit);
          this.addEventListener('shopify:block:select', this.handleBlockSelect);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
          this.removeEventListener('keydown', this.handleKeydown);
          this.removeEventListener('submit', this.handleSubmit);
          this.removeEventListener('shopify:block:select', this.handleBlockSelect);
          this.initialized = false;
        }

        activateTab(activeTab, moveFocus) {
          const panelId = activeTab.getAttribute('aria-controls');

          this.tabs.forEach((tab) => {
            const selected = tab === activeTab;
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
          });

          this.panels.forEach((panel) => {
            panel.hidden = panel.id !== panelId;
          });

          if (moveFocus) {
            activeTab.focus({ preventScroll: true });
            const tablist = activeTab.parentElement;
            const tabRect = activeTab.getBoundingClientRect();
            const listRect = tablist.getBoundingClientRect();

            if (tabRect.left < listRect.left) {
              tablist.scrollLeft += tabRect.left - listRect.left - 4;
            } else if (tabRect.right > listRect.right) {
              tablist.scrollLeft += tabRect.right - listRect.right + 4;
            }
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
